<app-nav-pages [solidNav]="true"></app-nav-pages>

<section class="hero-section d-flex justify-content-center align-items-end ">
  <div class="overlay"></div>
</section>

<section class="brand-wrapper py-5 ">
  <div class="container py-3 ">
    <h2 class="text-center" #textContent>THE SIGNATURE OF CLASS.</h2>

    <div class="brand-text text-center " #textContent>

      <p>The all suited RJ 5-Star Hotel has its Signature touches in all the smallest details. Experience the standard of bespoke excellence, where every facility is designed to make a statement.
        We understand the individuals who use our product are not just looking for a place to stay; they are seeking an experience that reflects their true identity and personal style. 
      </p>

    </div>


  </div>
</section>

<section class="container " #textContent>
  <img src="assets/imgs/introducing_rj.jpg" alt="Introduce Rj Hotel img" class="img-fluid">
</section>


<div class="my-5  d-flex flex-column ">
  <p class="quote_3_p text-center">NEXT <span class="rdj_bold">&#8594;</span></p>
  <h3 class="mb-3 text-center rdj_bold"> ZUMERA EXPERTISE</h3>
  <a routerLink="/what-we-do" class="know-more-btn align-self-center ">KNOW MORE</a>
</div>

<app-footer class="w-100 d-none d-sm-block"></app-footer>
<app-footer-sm  class="w-100 d-sm-none"></app-footer-sm>